export const deliverabilityPostmasterAppGroupIdIps = "/deliverability/postmaster/:app_group_id/ips";
